import './index.css'
import useUser from '../../hooks/useUser';
import useToken from '../../hooks/useToken';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { MailIcon, PersonArrowLeft, UserLogoutIcon } from '../common/Icons';
import { ModalOverlay } from '../common/BlockScreen';
import { useProject } from '../../context/ProjectContext';
import { useTicketsFilterContext } from '../../context/TicketsFilterContext';
import { PROFILE_ADMIN_CODE } from '../../assets/appConstants/constants';
import { APIResponseModel } from '../../models/api-call';
import { getPendingTasks } from '../../services/company.service';
import { getPersonAssignments } from '../../services/user.service';
import { useNotification } from '../../context/NotificationContext';


export default function AccountMenu() {
  const { setUser, user }: any = useUser()
  const { setSelectedProject, setProjectsList } = useProject()
  const { setDefaultTicketsFilter } = useTicketsFilterContext()
  const { setToken }: any = useToken()
  const [showAccountMenu, setShowAccountMenu] = useState(false);
  const closeAccountMenu = () => { setShowAccountMenu(false) }
  const { selectedProject } = useProject()
  const { showNotification } = useNotification();

  const [pendingEmails, setPendingEmails] = useState<number>(0)
  const [personAssignments, setPersonAssignments] = useState<number>(0)
  const one_minute = 60000

  const navigate = useNavigate()

  const handleCloseSession = (e: any) => {
    e.preventDefault()
    setSelectedProject('')
    setProjectsList([])
    setUser(null)
    setToken(null)
    setDefaultTicketsFilter()
    navigate("/")
  };

  const handleChangePassword = (e: any) => {
    navigate('/users-management/change-pwd')
  }

  const loadUserIndicators = () => {
    Promise.all([
      getPendingTasks(),
      getPersonAssignments()
    ]).then((results: APIResponseModel[]) => {
      setPendingEmails(results[0].data['pending'])
      setPersonAssignments(results[1].data['assignments'])
    }).catch((error) => {
      console.log(error.response.data.message)
      showNotification(error.response.data.message, 'error')
    })
  }

  useEffect(() => {
    const intervalId = setInterval(() => {
      loadUserIndicators()
    }, one_minute);

    return () => clearInterval(intervalId);

  }, [selectedProject]);

  useEffect(() => loadUserIndicators(), [])


  return (
    <>
      <div className='account-menu-section'>

        <div className='account-menu-assignments'>
          <PersonArrowLeft className='account-menu-personicon' />
          {(personAssignments >= 0) && (<>
            {personAssignments > 0 && (
              <span className='account-menu-badgeindicator'>
                {personAssignments}
              </span>
            )}
            <div className='tooltip assignments'>
              <span>{`Tienes ${personAssignments} tickets asignados`}</span>
            </div>
          </>)}
        </div>

        <div className='account-menu-mailicon' >
          <MailIcon />
          {(pendingEmails >= 0) && (<>
            {pendingEmails > 0 && (
              <span className='account-menu-badgeindicator'>
                {pendingEmails}
              </span>
            )}
            <div className='tooltip emails'>
              <span>{`Hay ${pendingEmails} notificaciones sin enviar`}</span>
            </div>
          </>)}
        </div>

        <button
          className='account-menu-icon'
          onClick={() => setShowAccountMenu(!showAccountMenu)}>
          {user.name.charAt(0) ?? ''}{user.last_name.charAt(0) ?? ''}
        </button>

      </div>

      <ModalOverlay show={showAccountMenu} onClose={closeAccountMenu} />
      <div className={`account-menu-modal-box ${showAccountMenu ? 'account-menu-modal-box__show' : ''}`}>
        <span className='account-menu-modal__user-info'>
          <p className='user-info__user'>{user.name} {user.last_name}</p>
          <p className='user-info__extra'>{user.username} {user?.profile_code === PROFILE_ADMIN_CODE ? '(Administrador)' : '(Usuario)'}</p>

          <span className='account-menu-modal__changepwd'>
            <button
              onClick={handleChangePassword}
            >
              Cambiar Contraseña
            </button>
          </span>
        </span>
        <div className="account-menu-modal__close-session">
          <button
            onClick={handleCloseSession}
          >
            Cerrar Sesión
          </button>
          <UserLogoutIcon className='close-session__icon' />
        </div>

      </div>
    </>
  );
}
